document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('tradeAppForm');
  const progressWrap = document.querySelector('.progress-wrap');
  const sections = Array.from(document.querySelectorAll('.form-section'));
  const tabs = Array.from(document.querySelectorAll('.form-progress .step-tab'));
  const backBtn = document.getElementById('backBtn');
  const nextBtn = document.getElementById('nextBtn');
  const submitBtn = document.getElementById('submitBtn');
  const thankYou = document.getElementById('thank-you');

  /* ===== Custom country list (exactly as provided) ===== */
  const COUNTRIES = [
    "Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Canary Islands","Cayman Islands","Central African Republic","Ceuta and Melilla","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo (the Democratic Republic of the)","Cook Islands","Costa Rica","Croatia","Curaçao","Cyprus","Czechia","Côte d'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Republic of)","Kosovo","Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","North Macedonia","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Romania","Rwanda","Réunion","Saint Barthélemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Taiwan (Province of China)","Tajikistan","Tanzania, the United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkmenistan","Turks and Caicos Islands","Tuvalu","Türkiye","Uganda","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Zambia","Zimbabwe","Åland Islands"
  ];

  /* ===== VAT countries ===== */
  const VAT_COUNTRIES = new Set([
    "Austria","Belgium","Bulgaria","Croatia","Cyprus","Czechia","Denmark","Estonia","Finland","France","Germany",
    "Greece","Hungary","Ireland","Italy","Latvia","Lithuania","Luxembourg","Malta","Netherlands","Poland",
    "Portugal","Romania","Slovakia","Slovenia","Spain","Sweden"
  ]);

  /* ===== Province map ===== */
  const PROVINCE_MAP = {
    "Australia": ["Australian Capital Territory","New South Wales","Northern Territory","Queensland","South Australia","Tasmania","Victoria","Western Australia"],
    "Canada": ["Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland","Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon"],
    "China": ["Anhui Province","Beijing","Chongqing","Fujian Province","Gansu Province","Guangdong Province","Guangxi A. R.","Guizhou Province","Hainan Province","Hebei Province","Heilongjiang Province","Henan Province","Hubei Province","Hunan Province","Neimenggu A. R.","Jiangsu Province","Jiangxi Province","Jilin Province","Liaoning Province","Ningxia A. R.","Qinghai Province","Shaanxi Province","Shandong Province","Shanghai","Shanxi Province","Sichuan Province","Tianjin","Xinjiang A. R.","Xizang A. R.","Yunnan Province","Zhejiang Province"],
    "Japan": ["Hokkaidō","Aomori","Iwate","Miyagi","Akita","Yamagata","Fukushima","Ibaraki","Tochigi","Gunma","Saitama","Chiba","Tokyo","Kanagawa","Niigata","Toyama","Ishikawa","Fukui","Yamanashi","Nagano","Gifu","Shizuoka","Aichi","Mie","Shiga","Kyoto","Osaka","Hyōgo","Nara","Wakayama","Tottori","Shimane","Okayama","Hiroshima","Yamaguchi","Tokushima","Kagawa","Ehime","Kochi","Fukuoka","Saga","Nagasaki","Kumamoto","Ōita","Miyazaki","Kagoshima","Okinawa"],
    "Mexico": ["Aguascalientes","Baja California","Baja California Sur","Campeche","Chiapas","Chihuahua","Coahuila","Colima","Durango","Guanajuato","Guerrero","Hidalgo","Jalisco","México (Estado de)","Michoacán","Morelos","Nayarit","Nuevo León","Oaxaca","Puebla","Querétaro","Quintana Roo","San Luis Potosí","Sinaloa","Sonora","Tabasco","Tamaulipas","Tlaxcala","Veracruz"],
    "United States": ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Puerto Rico","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming","Armed Forces Americas","Armed Forces Europe","Armed Forces Pacific"],
    "United Kingdom": ["Bedfordshire","Berkshire","Bristol","Buckinghamshire","Cambridgeshire","Cheshire","Cornwall","County Durham","Cumbria","Derbyshire","Devon","Dorset","East Riding of Yorkshire","East Sussex","Essex","Gloucestershire","Greater London","Greater Manchester","Hampshire","Herefordshire","Hertfordshire","Isle of Wight","Kent","Lancashire","Leicestershire","Lincolnshire","Merseyside","Norfolk","North Yorkshire","Northamptonshire","Northumberland","Nottinghamshire","Oxfordshire","Rutland","Shropshire","Somerset","South Yorkshire","Staffordshire","Suffolk","Surrey","Tyne and Wear","Warwickshire","West Midlands","West Sussex","West Yorkshire","Wiltshire","Worcestershire"]
  };

  /* ===== Channel map ===== */
  const CHANNEL_MAP = {
    "E-Tail": ["Market Place","Pure E-tailer","TBA"],
    "Retail": ["Accessories Retailer/Dealer","Furniture Retailer/Dealer","Hardware Retailer/Dealer","KBB Showrooms/ Studio","Light-bulb speciality Retailer/Dealer","Lighting Retailer/Dealer","Multi-Product Retailer/Dealer","LG Accessories Retailer/Dealer","LG Furniture Retailer/Dealer","LG KBB Design Studio/Showroom","LG Light-bulb speciality Retailer/Dealer","LG Hardware Retailer/Dealer","LG Lighting Retailer/Dealer","LG Multi-product Retailer/Dealer","TBA"],
    "Resellers/Wholesale": ["Agent Reseller","Electrical Distributor","Hardware Distributor","Home Automation/Integrator","Lighting Distributor","Multi Product Distributor","Electrical Wholesale","Hardware Wholesale","Multi-Product Wholesale","LG Electrical Wholesale","LG Hardware Wholesale","LG Multi-product Wholesale","LG Lighting Wholesale","TBA"],
    "Trade": ["Architects","Complimentary Manufacturer","Contractor","Food & Beverage Company","ID with Showroom","Interior Designer / Architect","Leisure Company","Lighting Designer","Maritime Company","Mill Work / Case goods Studio","Other Commercial","Procurement Agent","Builder Developer/Property Developer","LG Property Developer","TBA"],
    "Commercial": ["Hotels/Hospitality Group","Non-purchasing Architect","Non-purchasing Interior Designer/ IA","Non-purchasing Lighting Designer","Commercial/Contract Developer Group","TBA"],
    "Distribution - Resellers": ["TBA"],
    "Specifier (non-purch)": ["TBA"]
  };

  /* ===== Elements ===== */
  const countrySel = document.getElementById('AddressCountry');
  const provSelect = document.getElementById('AddressProvinceSelect');
  const provInput  = document.getElementById('AddressProvinceInput');
  const vatWrap    = document.getElementById('vat-wrapper');
  const primaryBusiness = document.getElementById('primary_business');
  const primaryChannel  = document.getElementById('primary_channel');

  /* Populate country list */
  function populateCountries() {
    countrySel.innerHTML = '';
    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'Select a country';
    countrySel.appendChild(blank);
    COUNTRIES.forEach(name => {
      const o = document.createElement('option');
      o.value = name;
      o.textContent = name;
      countrySel.appendChild(o);
    });
    countrySel.value = '';
  }

  /* Tabs */
  let currentStep = 1;
  function setTabError(step, hasError){
    const tab = tabs.find(t => Number(t.dataset.step) === step);
    if (tab) tab.classList.toggle('tab-error', !!hasError);
  }
  function showStep(step) {
    currentStep = step;
    sections.forEach(s => { s.hidden = Number(s.dataset.step) !== step; });
    tabs.forEach(t => {
      const active = Number(t.dataset.step) === step;
      t.classList.toggle('active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    backBtn.hidden = step === 1;
    nextBtn.hidden = step === sections.length;
    submitBtn.hidden = step !== sections.length;
  }
  tabs.forEach(tab => tab.addEventListener('click', () => showStep(Number(tab.dataset.step))));
  backBtn.addEventListener('click', () => showStep(Math.max(1, currentStep - 1)));

  /* Step validation */
  function validateCurrentSection() {
    const section = sections.find(s => Number(s.dataset.step) === currentStep);
    const inputs = section.querySelectorAll('input, select');
    let valid = true;
    inputs.forEach(el => el.classList.remove('bnp__invalid'));
    inputs.forEach(el => { if (!el.checkValidity()) { valid = false; el.classList.add('bnp__invalid'); } });
    setTabError(currentStep, !valid);
    if (!valid) {
      const bad = section.querySelector('.bnp__invalid');
      if (bad) { bad.reportValidity(); bad.focus({ preventScroll:false }); }
    }
    return valid;
  }
  nextBtn.addEventListener('click', () => { if (validateCurrentSection()) showStep(Math.min(sections.length, currentStep + 1)); });

  /* Channels */
  function populateChannels(){
    const arr = CHANNEL_MAP[primaryBusiness.value] || [];
    primaryChannel.innerHTML = '<option value="">Select a channel</option>';
    arr.forEach(txt => {
      const o = document.createElement('option');
      o.value = txt;
      o.textContent = txt;
      primaryChannel.appendChild(o);
    });
  }
  primaryBusiness.addEventListener('change', populateChannels);

  /* Province */
  function setProvinceNameAttr(useSelect){
    if(useSelect){ provSelect.name='province'; provInput.name=''; }
    else { provInput.name='province'; provSelect.name=''; }
  }
  function populateProvinceList(country){
    const list = PROVINCE_MAP[country];
    const required = (country === 'United Kingdom' || country === 'United States');
    if (Array.isArray(list) && list.length){
      provSelect.innerHTML = '<option value="">Select a state / county</option>';
      list.forEach(v => {
        const o = document.createElement('option');
        o.value=v; o.textContent=v;
        provSelect.appendChild(o);
      });
      provSelect.style.display='';
      provInput.style.display='none';
      provSelect.required=required;
      provInput.required=false;
      setProvinceNameAttr(true);
    } else {
      provInput.value='';
      provSelect.style.display='none';
      provInput.style.display='';
      provSelect.required=false;
      provInput.required=required;
      setProvinceNameAttr(false);
    }
  }

  /* Country change: VAT + province */
  function handleCountryChange(){
    const country = countrySel.value;
    vatWrap.hidden = !VAT_COUNTRIES.has(country);
    populateProvinceList(country);
  }
  countrySel.addEventListener('change', handleCountryChange);

  /* Validate all steps */
  function validateAll(){
    let overallValid = true, firstBadStep = null;
    sections.forEach(s => setTabError(Number(s.dataset.step), false));
    sections.forEach(sec => {
      const step = Number(sec.dataset.step);
      const fields = sec.querySelectorAll('input, select');
      let stepValid = true;
      fields.forEach(el => el.classList.remove('bnp__invalid'));
      fields.forEach(el => { if (!el.checkValidity()){ overallValid=false; stepValid=false; el.classList.add('bnp__invalid'); } });
      if (!stepValid){ setTabError(step,true); if(firstBadStep===null) firstBadStep=step; }
    });
    if (!overallValid && firstBadStep){
      showStep(firstBadStep);
      const fb=sections.find(s=>Number(s.dataset.step)===firstBadStep).querySelector('.bnp__invalid');
      if(fb){ fb.reportValidity(); fb.focus({preventScroll:false}); }
    }
    return overallValid;
  }

  /* Submit */
  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (!validateAll()) return;

    const fd = new FormData(form);
    const data = {};

    fd.forEach((v, k) => {
      let value = v;

      // Add https:// to website if missing
      if (k === "company_website" && value) {
        if (!/^https?:\/\//i.test(value)) {
          value = "https://" + value;
        }
      }

      data[k] = value;
    });

    fetch("https://tradeapps.busterandpunch.com",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body: JSON.stringify(data)
    })
    .then(res=>{ if(!res.ok) throw new Error("Submission failed: "+res.status); })
    .then(()=>{ form.style.display='none'; if(progressWrap) progressWrap.style.display='none'; thankYou.style.display='block'; })
    .catch(err=>{ console.error(err); alert("There was a problem submitting your form. Please try again."); });
  });

  /* Init */
  populateCountries();
  handleCountryChange();
  showStep(1);
});
